export default __webpack_public_path__ + "static/media/youtube-music-note.949c243b.svg";